import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import logo from "../../assets/img/CuronextFinal.png";
import CryptoJS from 'crypto-js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation } from 'react-router-dom';
import { commonAPI } from '../../services/CommonAPIService';
import { getNewToken } from '../../services/GenerateToken';
import InvitationScreen from './component/qrPage';
import { faMotorcycle, faCar, faEdit, faL, faPlus, faSort, faTrash, faEllipsisVertical, faTrashCan, faPenToSquare, faPaperclip, faBuilding, faChessQueen, faClock, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
// Styled component for the page container with background image
const PageContainer = styled.div`
  background-image: ${({ backgroundImage }) => backgroundImage ? `url('https://pentamind-backup-bucket.s3.ap-south-1.amazonaws.com/pentaminds/CuroCommon/prodenv/logos/${backgroundImage}')` : 'none'};
   background-size: contain; /* Show the full image */
    background-repeat: no-repeat;
    background-position: center center; /* Center the image */
    
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    
    font-family: 'Poppins', sans-serif;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    background-color: white;
`;

// Styled component for the header
const Header = styled.header`
  padding: 20px;
  width: 100%;
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
`;

// Styled component for the logo
const Logo = styled.img`
  width: 160px;
  filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.5));
  transition: transform 0.4s ease;
  &:hover {
    transform: rotate(5deg) scale(1.15);
  }
`;

// Styled component for the main content
const MainContent = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
  margin-top:20px;
  padding:20px
`;

// Styled component for the form container
const FormContainer = styled.div`
  background: rgba(255, 255, 255, 0.70);
  padding: 25px;
  border-radius: 20px;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 360px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 10px 35px rgba(0, 0, 0, 0.3);
  }
`;

// Styled component for the heading
const Heading = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: #ffffff; /* White for better contrast */
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.7), 0 0 15px rgba(0, 0, 0, 0.5); /* Stronger shadow */
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 1.2px;
  background: rgba(0, 0, 0, 0.3); /* Subtle background for readability */
  padding: 8px 16px;
  border-radius: 10px;
`;

// Styled component for the paragraph
const Paragraph = styled.p`
  font-size: 18px;
  color: #ffffff; /* White for better contrast */
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.7), 0 0 12px rgba(0, 0, 0, 0.5); /* Stronger shadow */
  margin-bottom: 25px;
  text-align: center;
  line-height: 1.5;
  font-weight: 400;
  background: rgba(0, 0, 0, 0.3); /* Subtle background for readability */
  padding: 6px 12px;
  border-radius: 8px;
`;

// Styled component for the label
const Label = styled.label`
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin-bottom: 10px;
  display: block;
  letter-spacing: 0.5px;
`;

// Styled component for the input field
const Input = styled.input`
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 10px;
  width: 100%;
  margin-bottom: 25px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
  font-size: 16px;
  background: #fff;
  transition: all 0.3s ease;
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 10px rgba(0, 123, 255, 0.4);
  }
  &::placeholder {
    color: #999;
    font-style: italic;
  }
`;

const InputVehicle = styled.input`
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 10px;
  width: 100%;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
  font-size: 16px;
  background: #fff;
  transition: all 0.3s ease;
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 10px rgba(0, 123, 255, 0.4);
  }
  &::placeholder {
    color: #999;
    font-style: italic;
  }
`;

const Button = styled.button`
  padding: 14px 28px;
  background: linear-gradient(135deg, #007bff, #00d4ff);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.4);
  &:hover {
    background: linear-gradient(135deg, #0062cc, #00b7ff);
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0, 123, 255, 0.6);
  }
  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 10px rgba(0, 123, 255, 0.3);
  }
`;

const SkipButton = styled(Button)`
  background: linear-gradient(135deg, #6c757d, #adb5bd);
  margin-left: 10px;
  &:hover {
    background: linear-gradient(135deg, #5a6268, #9ea7ad);
  }
`;

const SuccessMessage = styled.p`
  font-size: 20px;
  font-weight: 600;
  color: #28a745;
  background: rgba(255, 255, 255, 0.95);
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.6s ease-in-out;
  text-align: center;
  width: 100%;
  max-width: 360px;
  border: 1px solid rgba(40, 167, 69, 0.2);
  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.9); }
    to { opacity: 1; transform: scale(1); }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top:20px
`;

// Styled component for the submit button

// Styled component for the success message


const InvitePage = () => {
  const [FilterVisitor, setFilterVisitor] = useState()
  const [loading, setLoading] = useState(false)
  const [imageName, setImageName] = useState()
  const [buildingId, setBuildingId] = useState()
  const [groupId, setGroupId] = useState()
  const [lpValue, setLpValue] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showVehicleScreen, setShowVehicleScreen] = useState(false)
  const [VehicleTypeBtnBike, setVehicleTypeBtnBike] = useState(false);
  const [VehicleTypeBtnCar, setVehicleTypeBtnCar] = useState(false);
  const [VehicleType, setVehicleType] = useState()
  const [updateLpNumber, setUpdateLpNumber] = useState()
  const [phoneNumber, setPhoneNumber] = useState();
  const [saveDataForQr, setSaveDataForQr] = useState()
  const [userName, setUserName] = useState()
  const [info, setInfo] = useState()
  const [showFinalScreen, setShowFinalScreen] = useState(false)
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idParam = queryParams.get('id');
  const [showInvalidPage, setShowInvalidpage] = useState(false)


  const SECRET_KEY = process.env.REACT_APP_SECRET_KEY
  const IV = process.env.REACT_APP_IV
  const decryptAES = (ciphertext) => {
    try {
      if (!ciphertext) throw new Error("No ciphertext provided");
      const decrypted = CryptoJS.AES.decrypt(
        ciphertext,
        CryptoJS.enc.Utf8.parse(SECRET_KEY),
        {
          iv: CryptoJS.enc.Utf8.parse(IV),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      const result = decrypted.toString(CryptoJS.enc.Utf8);
      if (!result) throw new Error("Decryption resulted in empty string - possible wrong key/IV");
      return result;
    } catch (error) {
      console.error("Decryption failed:", error.message);
      setShowInvalidpage(true)
      throw error;
    }
  };

  const urlSafeEncodedBase64String = (base64String) => {
    return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  };

  const fromUrlSafeBase64String = (urlSafeEncodedBase64String) => {
    let base64 = urlSafeEncodedBase64String.replace(/-/g, '+').replace(/_/g, '/');

    // Add padding if needed
    const padding = base64.length % 4;
    if (padding === 2) base64 += "==";
    else if (padding === 3) base64 += "=";

    return base64;
  };

  async function getDataForApiCall() {
    // Guard clause to prevent API call if data is incomplete
    if (!buildingId || !groupId) {
      //console.log("Skipping API call: buildingId or groupId is missing");
      return;
    }
    try {
      const dec = fromUrlSafeBase64String(idParam)
      const bodyReq = {
        "groupInviteKey": dec,
        "mobileNumber": phoneNumber
      }

      const response = await commonAPI('GetGroupInviteVisitor', bodyReq, undefined);
      if (response != null && response.success == true && response.message.length == 0) {
        //console.log(response.data, "RESPONSEData");
        if (response.data) {
          if (response.data.key) {
            setInfo(response.data)
            setSaveDataForQr(response.data.key)
            setShowFinalScreen(true)
          }
          else {
            handleNext()
           // console.log("hiiii")
            setInfo(response.data)
          }
        }

      }
      else {
        alert("CuroNext", "something went wrong")
      }

    } catch (error) {
      console.log("API call failed:", error);
    }
  }

  // Single useEffect to handle decryption and API call



  const fetchData = async () => {
    try {
      const dec = fromUrlSafeBase64String(idParam)
     // console.log(dec, "GetBase64")
      const decryptedData = decryptAES(dec);
      const [buildingId, decryptedGroupId, decryptedImageName,] = decryptedData.split("|");
      setBuildingId(buildingId)
      setGroupId(decryptedGroupId)
      setImageName(decryptedImageName)
     // console.log(decryptedData, "DecryptedData")
    } catch (error) {
      console.error("useEffect decryption or API error:", error);
    }
  };


  async function visitorTypes() {
    if (!buildingId || !groupId) {
      console.log("Skipping API call: buildingId or groupId is missing");
      return;
    }
    try {
      const endPointVariableKey =
      {
        buildingId: buildingId
      }
      const response = await commonAPI("visitorType", undefined, endPointVariableKey)
      //console.log(response, "RESPONSE")
      const filterVisitorType = [];
      const otherFilterVisitorType = [];
      for (let i = 0; i < response?.data?.length; i++) {
        if (response?.data[i]?.visitorType.includes("Guest")) {
          filterVisitorType.push(response.data[i])
        }
      }
      setFilterVisitor(filterVisitorType)
     // console.log(filterVisitorType, endPointVariableKey, "FilterVisitor")
      //console.log(otherFilterVisitorType)
    }
    catch (error) {
      console.log(error)
    }

  }


  useEffect(() => {
    fetchData()
  }, [])


  useEffect(() => {
    visitorTypes()
  }, [buildingId, groupId])

  async function addVisitor(infoData, visitorTypeId) {
    //console.log(visitorTypeId, "VisitorTypeId")

    const bodyReq = {
      "currentStatus": "APPROVED",
      "flatId": infoData?.flatId,
      "lpNumber": lpValue ? lpValue : null,
      "mobileNumber": phoneNumber,
      "towerId": infoData?.towerId,
      "vehicleType": VehicleType ? VehicleType : null,
      "visitEndDt": infoData?.visitEndDt,
      "visitStartDt": infoData?.visitStartDt,
      "visitorCategory": VehicleType ? "VEHICLE" : 'WALKIN',
      "createdUserId": infoData.createdUserId,
      "visitorName": userName,
      "visitorTypeId": visitorTypeId[0].visitorTypeId,
      "groupRequestId":groupId
    }
    //console.log(bodyReq, "BodyReq")

    
    const endPointVariableKey =
    {
      buildingId: infoData.buildingId
    }

    //console.log("bodyReq", bodyReq)
    try {
      //console.log("userData", user())
      setLoading(true)
      const response = await commonAPI("MyVisitorListPost", bodyReq, endPointVariableKey)
     // console.log(response)
      if (response?.success == true && response?.message?.length == 0) {
      //  console.log(response)
        setSaveDataForQr(response.data.visitorQRCodeString)
        setShowFinalScreen(true)
      }
      else {

        setLoading(false)
        alert(response.message[0])
       // console.log("Response", response)


      }
    }
    catch (error) {
      const bodyError = {
        userId: infoData?.userId,
        mobileNumber: infoData?.mobileNumber,
        requestJSON: "",
        uri: "Add visitor",
        errorNumber: "AV02",
        errorSource: "App",
        errorSummary: error.Message,
        errorDescription: error.toString(),
        fileClassName: "Visitor.js",
        functionName: "addVisitor",
      }
      let response = await commonAPI('ErrorLogMaster', bodyError);

      if ((response.status === 200) & (response.message.length == null)) {
        alert("CuroNext", 'Something went wrong catch');
        setLoading(false);
      } else {
        alert("CuroNext", 'Something went wrong catch');
        setLoading(false);
      }
    }
  }

  const VehicleCar = async () => {
    setVehicleTypeBtnCar(true)
    setVehicleTypeBtnBike(false)
    setVehicleType("4WHEELER")
  }
  const VehicleBike = async () => {
    setVehicleTypeBtnCar(false)
    setVehicleTypeBtnBike(true)
    setVehicleType("2WHEELER")
  }
  const handleNext = () => {
    if (!phoneNumber || phoneNumber.length !== 10) {
      alert("Please enter a valid 10 digit number");
      return;
    }
    setShowVehicleScreen(true);
  };


  return (
    <>
      {showInvalidPage ? <div style={{
        height: "100vh",
        backgroundColor: "#30373d",
        color: "#ffffff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        textAlign: "center"
      }}>
        <h1 style={{ fontSize: "2rem", color: "#258dc4", marginBottom: "10px" }}>Oops! Something went wrong</h1>
        <p style={{ maxWidth: "400px" }}>Please try refreshing the page or come back later. If the issue persists, contact support.</p>
      </div> : <PageContainer backgroundImage={imageName ? `${imageName}` : null}>
        <Header>
          <Logo src={logo} alt="Event Logo" />
        </Header>
        {!showFinalScreen && <MainContent>
          {isSubmitted ? (
            <SuccessMessage>Thank you for your response!</SuccessMessage>
          ) : (
            <>
              {/* <Heading>You're Invited!</Heading>
            <Paragraph>Join us for the Chill Party on April 10th, 2025</Paragraph> */}
              {!showFinalScreen && <FormContainer>
                <>
                  {!showVehicleScreen && <div>
                    <Input
                      id="invite-input"
                      type="tel"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder="Enter your Phone Number"
                    />

                  </div>}


                  {showVehicleScreen && <>

                    <div className="note2">
                      <p><FontAwesomeIcon icon={faExclamationCircle}></FontAwesomeIcon> Kindly fill your vehicle detail for seamless entry in the premises</p>
                    </div>

                    <div className="col-md-12 mb-2 text-center">
                      <Input
                        id="invite-input"
                        type="text"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        placeholder="Enter your Name"
                      />
                      <div className='fam_vehicleBtn'>


                        {VehicleTypeBtnCar ?
                          <FontAwesomeIcon icon={faCar} onClick={() => VehicleCar()} className='fam_vehicleBtnicon bg-info text-white' />
                          :
                          <FontAwesomeIcon icon={faCar} onClick={() => VehicleCar()} className='fam_vehicleBtnicon text-info border-info' />
                        }
                        {VehicleTypeBtnBike ?
                          <FontAwesomeIcon icon={faMotorcycle} onClick={() => VehicleBike()} className='fam_vehicleBtnicon bg-info text-white' />
                          :
                          <FontAwesomeIcon icon={faMotorcycle} onClick={() => VehicleBike()} className='fam_vehicleBtnicon text-info border-info' />


                        }
                      </div>
                    </div>

                    <InputVehicle
                      id="invite-input"
                      type="text"
                      value={lpValue}
                      onChange={(e) => setLpValue(e.target.value)}
                      placeholder="Enter Full vehicle number"
                    />
                    <ButtonContainer>
                      <Button onClick={() => addVisitor(info, FilterVisitor)}>SUBMIT</Button>
                      <SkipButton onClick={() => { addVisitor(info, FilterVisitor) }}>Skip</SkipButton>
                    </ButtonContainer>
                  </>}




                  {!showVehicleScreen && <ButtonContainer>
                    <Button onClick={() => { getDataForApiCall() }}>Next</Button>

                  </ButtonContainer>}
                </>
              </FormContainer>}
            </>
          )}
        </MainContent>}
        {showFinalScreen && <InvitationScreen Qrdata={saveDataForQr} data={info} />}
      </PageContainer>}

    </>

  );
};

export default InvitePage;